import React, { useState } from 'react';
import './BulkUpdateModal.css';
import { Modal, Button } from 'react-bootstrap';
import { REASONS } from '../../constants/JitManagement';

const JitStatusBulkUpdateModal = ({
  show,
  onHide,
  onConfirm,
  checkedItems,
  loading = false,
}) => {
  const [status, setStatus] = useState('Complete');
  const [reason, setReason] = useState(REASONS[0].value);

  useState(() => {
    setReason(REASONS[0].value);
  }, [status]);

  return (
    <Modal
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
    >
      <Modal.Header closeButton onHide={loading ? undefined : onHide}>
        <Modal.Title id="contained-modal-title-vcenter" className="modalTitle">
          JIT Status Bulk Update
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="bodyText">
          Please, choose JIT Status and Reason that you want to apply for{' '}
          <b>{checkedItems}</b> items that you checked
        </p>
        <div className="modalRow">
          <div className="dropdownWrapper">
            <div className="title">JIT Status</div>
            <select onChange={(e) => setStatus(e.target.value)} value={status}>
              <option value="Off">Off</option>
            </select>
          </div>
          <div className="dropdownWrapper">
            <div className="title">Reason</div>
            <select onChange={(e) => setReason(e.target.value)} value={reason}>
              {REASONS.map(({ value, text }) => (
                <option value={value} key={value}>
                  {text}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} disabled={loading} className="footerButton">
          Close
        </Button>
        <Button
          onClick={() => onConfirm(status, reason)}
          className="btn-success footerButton"
          disabled={loading}
        >
          {loading ? 'Loading...' : 'Update JIT'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default JitStatusBulkUpdateModal;
